import { toast, cssTransition } from "react-toastify";
import { closeSnackbar, enqueueSnackbar } from "notistack";
import { Button, styled } from "@mui/material";
import SuccessAlert from "../assets/audio/success.mp3";
import DangerAlert from "../assets/audio/danger.mp3";
import WarnAlert from "../assets/audio/warn.mp3";

export const bounce = cssTransition({
  enter: "animate__animated animate__bounceIn",
  exit: "animate__animated animate__bounceOut",
});

const playAudio = (audioFile) => {
  const audio = new Audio(audioFile);
  audio.play().catch((err) => {
    // Silence the "NotAllowedError" which occurs if the user hasn't interacted with the page yet.
    // This is a standard browser security feature.
    console.debug("Audio playback silenced:", err.message);
  });
};

const StyledButton = styled(Button)(({ theme }) => ({
  color: "white",
  marginLeft: theme.spacing(1),
}));

const snackbarVariants = {
  message: {
    audio: DangerAlert,
    backgroundColor: "#d32f2f",
  },
  "message-warn": {
    audio: WarnAlert,
    backgroundColor: "rgb(17 134 223)",
  },
};

const handleSnackbar = (color, text) => {
  const variant = snackbarVariants[color];
  if (!variant) return null;

  enqueueSnackbar(
    <span
      dangerouslySetInnerHTML={{
        __html: text,
      }}
    />,
    {
      anchorOrigin: { vertical: "top", horizontal: "right" },
      autoHideDuration: null,
      action: (key) => (
        <StyledButton
          onClick={() => {
            closeSnackbar(key);
          }}
        >
          Cancel
        </StyledButton>
      ),
      style: {
        backgroundColor: variant.backgroundColor,
        color: "#fff",
      },
    }
  );

  return variant.audio;
};

const toastConfig = (color, text, time) => {
  const show = time ? time : 1000;
  const options = {
    transition: bounce,
    autoClose: show,
  };

  switch (color) {
    case "success":
      toast.success(text, options);
      return SuccessAlert;
    case "error":
      toast.error(text, options);
      return DangerAlert;
    case "info":
      toast.info(text, options);
      return WarnAlert;
    case "warn":
      toast.warn(text, options);
      return WarnAlert;
    case "default":
      toast(text, options);
      return WarnAlert;
    default:
      return null;
  }
};

export function animateCss(color, text, time) {
  let audioFile = handleSnackbar(color, text);

  if (!audioFile) {
    audioFile = toastConfig(color, text, time);
  }

  if (audioFile) {
    playAudio(audioFile);
  }
}
